import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Color} from "../types/Color";

const emptyArray: Color[] = [];

export const useGetColors = (dealerID: number, prodQteGrpID: number, pricingDate: Date, zipCode: string, enabled: boolean) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-tool-colors', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-tool/colors?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&pricingDate=' + pricingDate.toISOString() + '&zipCode=' + zipCode) as Color[],
        enabled: prodQteGrpID > 0 && enabled,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || emptyArray,
        isLoading: isLoading
    };
};
